// app/event-analysis/[symbol]/page.tsx
'use client'

import React from 'react'
import { useParams } from 'next/navigation'
import StockChart from '../../../components/Plugins/EventAlerts/StockChart'
import EventAlerts from '../../../components/Plugins/EventAlerts/EventAlerts'

const EventAnalysisPage: React.FC = () => {
  const params = useParams()
  const symbol = typeof params!.symbol === 'string' ? params!.symbol : ''

  return (
    <div
      style={{
        width: 'auto',
        height: '100vh',
        padding: '20px',
        backgroundColor: '#f6f9fd',
        color: '#88a1ac'
      }}
    >
      <h2 style={{ fontSize: '1.6rem', textAlign: 'center', color: '#333' }}>
        Event Analysis
      </h2>
      <h1>Event-Driven Analysis for {symbol.toUpperCase()}</h1>
      <StockChart ticker={symbol.toUpperCase()} />
      <EventAlerts ticker={symbol.toUpperCase()} />
    </div>
  )
}

export default EventAnalysisPage
